import React from 'react'
import {
  TextField,
  CircularProgress,
  Grid,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  makeStyles,
  Container,
} from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import { useDispatch, useSelector } from 'react-redux'
import { useGetPlacesByNameQuery } from '../services/mapbox'
import { distanceSelector, DISTANCE_OPTIONS, setDistance } from '../slices/locator'

const useStyles = makeStyles( {
  label : {
    fontSize : 10,
  },
  container : {
    background : '#ffffff',
  },
} )

function Search( {
  onInputChange, onChange, inputValue, loading,
} ) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const distance = useSelector( distanceSelector )
  const onChangeDistance = ( evt, value ) => {
    dispatch( setDistance( parseInt( value, 10 ) ) )
  }

  const { data = {}, isLoading } = useGetPlacesByNameQuery( inputValue, {
    skip : inputValue.length < 3,
  } )

  const options = data.features || []

  return (
    <Container className={classes.container} maxWidth="xl">
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <Autocomplete
            id="search"
            onInputChange={onInputChange}
            onChange={onChange}
            popupIcon={null}
            getOptionSelected={( option, value ) => option?.place_name === value}
            getOptionLabel={( option ) => option?.place_name}
            options={options}
            inputValue={inputValue}
            clearOnBlur={false}
            renderInput={( params ) => (
              <TextField
                {...params}
                label="Search"
          // variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment : (
                    <>
                      {isLoading || loading ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item>
          <div>
            <FormLabel>Within:</FormLabel>
            <RadioGroup
              row
              name="distance"
              value={distance}
              onChange={onChangeDistance}
            >
              {DISTANCE_OPTIONS.map( ( option ) => (
                <FormControlLabel
                  key={option}
                  classes={{
                    label : classes.label,
                  }}
                  label={`${option} miles`}
                  control={<Radio size="small" />}
                  value={option}
                />
              ) )}
            </RadioGroup>
          </div>
        </Grid>
      </Grid>
    </Container>
  )
}

export default Search
